import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled, Dialog, dialogClasses, useMediaQuery } from '@mui/material';
import reducer, { closeDialogById, selectDialogs, type StyledDialogComponentProps } from 'app/store/fuse/dialogSlice';
import withReducer from 'app/store/withReducer';

const StyledDialog = styled(Dialog, {
	shouldForwardProp: propName => {
		return propName !== 'fullHeight';
	}
})<StyledDialogComponentProps>(({ fullHeight = false }) => ({
	...(fullHeight
		? {
				[`& .${dialogClasses.paper}`]: {
					height: '100%'
				}
			}
		: {})
}));

function FuseDialog() {
	const dispatch = useDispatch();
	const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

	const dialogs = useSelector(selectDialogs);

	// usePopState(() => dispatch(closeDialog()));

	return dialogs.map(({ id, options, state }) => {
		const fullScreen = options.fullScreen || (isMobile && options.maxWidth !== 'xs');

		function handleClose(event, reason) {
			// if (options.onClose) options.onClose(event, reason);
			dispatch(closeDialogById(id));
		}

		return (
			<StyledDialog
				key={id}
				open={state}
				onClose={handleClose}
				classes={
					options.classes || {
						paper: !fullScreen ? 'rounded-8' : 'rounded-none'
					}
				}
				fullScreen={fullScreen}
				{...options}
			/>
		);
	});
}

export default withReducer('dialogs', reducer)(FuseDialog);
